import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiFileText, FiGlobe } = FiIcons;

const Header = () => {
  return (
    <motion.header 
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="bg-white shadow-lg border-b-4 border-blue-500"
    >
      <div className="container mx-auto px-4 py-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-blue-600 rounded-lg flex items-center justify-center">
              <SafeIcon icon={FiFileText} className="text-white text-2xl" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-800">
                Prosperity Leaders™
              </h1>
              <p className="text-blue-600 font-medium">Community Outreach Letter Generator</p>
            </div>
          </div>
          
          <div className="flex items-center space-x-2 bg-blue-50 px-4 py-2 rounded-lg">
            <SafeIcon icon={FiGlobe} className="text-blue-600" />
            <span className="text-blue-700 font-medium">Bilingual Support</span>
            <span className="text-2xl">🇪🇸🇺🇸</span>
          </div>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;